export default __webpack_public_path__ + "static/media/acut.915b717e.png";